<template>
    <div
        class="betslip-compact"
        @click="$emit('expand')"
    >
        <div class="betslip-compact__info-box status">
            <div class="ticket-stack__item-status">
                <i
                    v-if="hasLiveEvents"
                    class="ticket-stack__item-status-live icon icon-dot_circle"
                />
                <div
                    class="ticket-stack__item-status-icon"
                >
                    <span class="status__events-left">
                        {{ numberOfEvents }}
                    </span>
                </div>
            </div>
        </div>
        <div class="betslip-compact__info-box coefficient">
            <div class="betslip-compact__label">
                {{ $t('quote') | capitalize }}
            </div>
            <div class="betslip-compact__number">
                {{ coefficient | twoDecimals }}
            </div>
        </div>
        <div class="betslip-compact__info-box stake">
            <div class="betslip-compact__label">
                {{ $t('stake') | capitalize }}
            </div>
            <div class="betslip-compact__number">
                {{ stake }}
                <span class="currency">{{ $t('currencyAbbreviation') }}</span>
            </div>
        </div>
        <div class="betslip-compact__info-box potential-win">
            <div class="betslip-compact__label">
                {{ `${$t('potential win')}` | capitalize }}
            </div>
            <div class="betslip-compact__number">
                {{ Math.min(potentialWin) | currency }}
                <span class="currency">{{ $t('currencyAbbreviation') }}</span>
            </div>
        </div>
        <button class="btn expand-button">
            <i class="icon icon-chevron_up" />
        </button>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';

    export default {
        props: {
            coefficient: {
                type: Number,
                required: true,
            },
            stake: {
                type: Number,
                required: true,
            },
            hasLiveEvents: {
                type: Boolean,
                default: false,
            },
            numberOfEvents: {
                type: Number,
                default: 1,
            },
            potentialWin: {
                type: Number,
                required: true,
            },
        },
        destroyed() {
            this.clearSubscriptions();
        },
        methods: {
            ...mapActions('data/sportOffer', ['clearSubscriptions']),
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/mobile/shared/components/BetSlipCompact/BetSlipCompact.vue